module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lUG1Es/tc-custom/FC-9781528995900.jpg?1684515571846?1709061808884",
      "alt": "This image is the cover for the book Laszlo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Laszlo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Laszlo works as an embalmer in a funeral director, where he’s worked since he left school. He feels bored, he feels his life is going nowhere, and he craves some adventure. His life changes when he goes to the morgue to collect Joseph Figg, also known as Big Joe, the murdered head of a gangster family. Laszlo becomes familiar with some members of the Figg family while Big Joe is at rest in the chapel; encounters he finds utterly unnerving. He somehow manages to get himself involved with gangster business, which initially increases his worried state of mind, but quickly has him in fear for his life. He turns to a close friend for advice, and the two hatch a plan to get Laszlo out of the situation he’s got himself into. The friend, in turn, reconnects with some old friends to help with the plan; people Laszlo must now rely on. Laszlo also finds romance when he meets someone he connects with, but this is hardly an ideal time to be starting a new relationship.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert Kerr\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0